/**
 * One plan for bank money (TMMAPP-0173 items 8 and 9; TMMAPI-0202, MM-D-154): the sentence that names
 * the bank series' slice a plan line repeats, from the `409 PLAN_LINE_LIKELY_DUPLICATE` details or a
 * listed line's `likelyDuplicateOf`. tmm-api decides the duplicate and serves the slice as the reader
 * reads it: a published reader gets no account name (MM-D-130) and may get no series name, so the
 * sentence drops what isn't served and never fills it in.
 */
import type { TFunction } from 'i18next';
import type { LikelyDuplicateDetails } from '@/api/errors';
import { formatCivilDate, formatMoneyMinor } from '@/i18n/format';

export function duplicateSentence(
  t: TFunction,
  slice: LikelyDuplicateDetails,
  currency: string | null,
  locale: string,
): string {
  if (slice.amountMinor === null || slice.nextOn === null) {
    return t('errors.planLineLikelyDuplicate');
  }
  const values = {
    series: slice.seriesName ?? '',
    account: slice.accountName ?? '',
    amount: formatMoneyMinor(Math.abs(slice.amountMinor), currency, locale),
    date: formatCivilDate(slice.nextOn, locale),
  };
  if (slice.seriesName === null) return t('planLines.duplicateWarningNoName', values);
  if (slice.accountName === null) return t('planLines.duplicateWarningNoAccount', values);
  return t('planLines.duplicateWarning', values);
}
